const getLocaleDateOrder = () => {
  const { locale } = Intl.DateTimeFormat().resolvedOptions();
  const formatObj = new Intl.DateTimeFormat(locale).formatToParts(new Date());
  return {
    separator: formatObj.find((obj) => obj.type === 'literal')?.value ?? '/',
    isMonthFirst: formatObj[0]?.type === 'month',
  };
};

export const formatLabel = ({
  start,
  end,
  month,
}: {
  start: string;
  end: string;
  month: string;
}) => {
  const { separator, isMonthFirst } = getLocaleDateOrder();
  const startOfMonth = isMonthFirst
    ? `${month}${separator}${start}`
    : `${start}${separator}${month}`;
  const endOfMonth = isMonthFirst ? `${month}${separator}${end}` : `${end}${separator}${month}`;
  return `${startOfMonth} - ${endOfMonth}`;
};

export const formatShortDate = (month: string, day: string) => {
  const { separator, isMonthFirst } = getLocaleDateOrder();
  return isMonthFirst ? `${month}${separator}${day}` : `${day}${separator}${month}`;
};
